import type { ReactNode, ElementType } from "react";

interface Props {
  children: ReactNode;
  as?: ElementType;
}

/**
 * **WARNING**: Test your changes using Fullstory's preview mode
 * and get compliance sign-off before merging. Accidentally exposing
 * PI/PHI in live session recordings is a compliance violation.
 *
 * Wraps an element and marks it as safe to capture in Fullstory
 * session recordings. All text is redacted by default, so anything
 * wrapped with this component, including all descendants, will be visible.
 *
 * **Docs**
 * @see {@link https://engineering.docs.fullscript.cloud/Guides/How%20to/apply-selective-redaction-in-fullstory Engineering docs - How To Apply Selective Redaction}
 * @see {@link https://app.getguru.com/card/ipgMry4T/-What-is-considered-PHI-and-Personal-Information What is considered PHI and Personal Information}
 * @see {@link https://app.getguru.com/card/irg6ReqT/HIPAA-Identifiers- HIPAA Identifiers}
 */

const FullstorySafeToCapture = ({ children, as = "div" }: Props) => {
  const Component = as;

  return <Component data-fs-safe-to-capture>{children}</Component>;
};

export { FullstorySafeToCapture };
